import Link from "next/link"
import { useLocalizedField } from '@/hooks/useLocalizedField'
import { useLocale } from 'next-intl'

interface DestinationCardProps {
  item: any
}

export default function DestinationCard({ item }: DestinationCardProps) {
  const { getLocalizedField } = useLocalizedField()
  const locale = useLocale()
  
  return (
    <Link
      href={`/destinations/${item.slug}`}
      className="group relative h-64 sm:h-80 md:h-96 w-full sm:w-52 md:w-60 overflow-hidden rounded-2xl sm:rounded-3xl cursor-pointer"
    >
      <img
        src={item.vignette}
        alt={getLocalizedField(item, 'name')}
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
      />

      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/50" />

      <div className="absolute bottom-4 sm:bottom-6 md:bottom-8 left-4 sm:left-6 right-4 sm:right-auto p-2 sm:p-4 flex items-end">
        <h2 className={`text-white font-bold text-base sm:text-lg origin-bottom-left whitespace-nowrap ${
          locale === 'ar' ? 'rotate-0 sm:rotate-90 translate-y-0 sm:translate-y-full' : 'rotate-0 sm:-rotate-90 translate-y-0 sm:translate-y-full'
        }`}>
          {getLocalizedField(item, 'name')}
        </h2>
      </div>
    </Link>
  )
}
